import { DEFAULT_SWIM_SET } from "../domain/swimming/constants";
import { DEFAULT_STRENGTH_SET } from "../domain/strength/constants";
import { DEFAULT_RUNNING_SEGMENT } from "../domain/running/constants";
import { DEFAULT_WOD_MOVEMENT } from "../domain/wod/constants";

export const DEFAULT_SET_BY_TYPE = {
    swimming: DEFAULT_SWIM_SET,
    strength: DEFAULT_STRENGTH_SET,
    running:  DEFAULT_RUNNING_SEGMENT,
    wod:      DEFAULT_WOD_MOVEMENT,
};

export const DEFAULT_BLOCKS_BY_TYPE = {
    swimming: [],
    strength: [],
    running: [],
    wod: [],
};
